// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pmxV","option":"styles_option__2YfHX","selected":"styles_selected__20pqn"};